import { render, staticRenderFns } from "./institutionalBilling.vue?vue&type=template&id=284e1ef0&scoped=true"
import script from "./institutionalBilling.vue?vue&type=script&lang=js"
export * from "./institutionalBilling.vue?vue&type=script&lang=js"
import style0 from "./institutionalBilling.vue?vue&type=style&index=0&id=284e1ef0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284e1ef0",
  null
  
)

export default component.exports